import React from 'react'
import { UserContextProvider } from '../context/UserContext'
import Layout from '../components/Layout'
import StrapiTable from '../sections/StrapiTable'
import { VIDEO_TABLE_HEADERS } from '../constants/table-header'
import { useNavigate } from 'react-router-dom'
import { deleteVideo, getAllVideo } from '../services/video.service'
import { toast } from 'react-toastify'

const ListBeritaAds = () => {
  const navigate = useNavigate()
  const onDelete = async (id) => {
    try {
      await deleteVideo({ id })
      navigate(0)
    } catch (error) {
      toast.error(error?.response?.data?.error?.message ?? 'Error')
    }
  }

  return (
    <UserContextProvider>
      <Layout activeNav="Video">
        <div className="p-3 lg:pl-0">
          <StrapiTable
            title="Video"
            headers={VIDEO_TABLE_HEADERS}
            createLink="/konten/video/create"
            fetchFunction={getAllVideo}
            onDelete={(id) => onDelete(id)}
            onEdit={(id) => navigate(`/konten/video/edit/${id}`)}
          />
        </div>
      </Layout>
    </UserContextProvider>
  )
}

export default ListBeritaAds
